import { create } from 'zustand';

interface NavigationState {
  navigationFunction: (() => void) | undefined;
  setNavigationFunction: (fn: (() => void) | undefined) => void;
}

export const useNavigationStore = create<NavigationState>((set) => ({
  navigationFunction: undefined,
  setNavigationFunction: (navigationFunction) => set({ navigationFunction }),
}));
